// Global Variable

$(function () {
    console.log('Hello world!3');
    // openGameWidget();
    initDate();
    onLoadCookieBar();
    setTimeout(function () {
      initFlickity('jsc-recommendations-slider');
    }, 900);
    initShopByCategorySlider();
    initShopByCategorySlider2();
    initFeaturedCollectionSwiper();
    initStylingGuideSwiper();
    MiniSliderSwiper();

    var $html = `<div class="jsc-page-loading" style="display: none;">
                  <div class="jsc-spinner-container">
                    <div class="jsc-spinner"></div>
                  </div>
                </div>`;
    $('body').prepend($html);

    if (location.href.includes('/cart')) {
      masterPromo(false);
    }
    getTaxAttr();
    checkBannerVisible();
    openChatFromPageFly();
    removeOneCardError();
});

openGameWidget = () =>{
  var $widget = $('.rhym-float-widget');

  if ($widget.length > 0 && !sessionStorage.getItem('gameWidgetOpened')) {
    $widget.click();
    sessionStorage.setItem('gameWidgetOpened', 'true');
  }
}

// Start toggle sliders tab
onClckToggleSlider = (curr,aft,evt,slide) =>{
  var $this = $(evt);
  $('.jsc-tggle-tab').removeClass('_isSelectedTab');
  $this.addClass('_isSelectedTab');

  $('._jsc-'+curr).show(); // show selected tab
  $('._jsc-'+aft).hide();
  
  initFlickity(slide);
}
// End toggle sliders tab

// Start PDPA Function

customerAPI = (fn,ln,id,tel,birth,oTel,oBirth,prov,gen,oPro,oGen,oPdpa,nPdpa,pdpaId,pdpaIdList) =>{

    let $data = {
        id: id,
        first_name: fn,
        last_name: ln,
        telephone: `__tel:${tel}`,
        birthday: `__birthday:${birth}`,
        province: `__province:${prov}`,
        gender: `__gender:${gen}`,
        old_tel: oTel,
        old_brith: oBirth,
        old_pro: oPro,
        old_gen: oGen,
        old_pdpa: oPdpa,
        pdpa: nPdpa,
        pdpaId: `__id:${pdpaId}`,
        pdpaList: pdpaIdList
    };

    $.ajax({
        url: 'https://webhooks.mechanic.dev/fb2df8ad-c053-461e-86ee-19c61219acf6',//user/custom/customer
        method: 'POST',
        headers: {
        'content-type': 'application/json'
        },
        data: JSON.stringify($data)
    });
}

customerInitAPI = (fn,ln,id,tel,birth,prov,gen,pdpa, pdpaId,email) =>{

    let $data = {
        id: id,
        first_name: fn,
        last_name: ln,
        telephone: `__tel:${tel}`,
        birthday: `__birthday:${birth}`,
        province: `__province:${prov}`,
        gender: `__gender:${gen}`,
        pdpa: `__pdpa:${pdpa}`,
        pdpaId: `__id:${pdpaId}`,
        email: email
    };

    $.ajax({
        url: 'https://webhooks.mechanic.dev/da20ced8-4b6e-4bc8-ba5d-3f88a23565b5', //user/custom/update
        method: 'POST',
        headers: {
        'content-type': 'application/json'
        },
        data: JSON.stringify($data)
    });
}

validateUpdate = ($first_name, $last_name, $telephone, $birthday) =>{
    var $isError = true;

    if ($first_name == '') {
        $('#first_name_error').show();
        $isError = false;
    } else {
        $('#first_name_error').hide();
    }
    if ($last_name == '') {
        $('#last_name_error').show();
        $isError = false;
    } else {
        $('#last_name_error').hide();
    }
    if ($telephone == '') {
        $('#telephone_error').show();
        $isError = false;
    } else {
        if ($telephone.length == 10) {
        $('#telephone_valid').hide();
        } else {
        $isError = false;
        $('#telephone_valid').show();
        }
        $('#telephone_error').hide();
    }
    if ($birthday == '') {
        $('#birthday_error').show();
        $isError = false;
    } else {
        $('#birthday_error').hide();
    }

    return $isError;
}

updatePdpa = (evt) =>{
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    var $this = $(evt);
    var $id = parseInt($('#jsc-customer-pdpa-id').val());
    var $idList = $('#jsc-customer-pdpa-id-list').val();
    var $shopifyId = parseInt($('#jsc-customer-id').val());
    var $first_name = $('#FirstName').val();
    var $last_name = $('#LastName').val();
    var $email = $('#Email').val();
    var $telephone = $('#jsc-register_mobile').val();
    var $birthday = $('#jsc-birthday').val();
    var $province = $('#jsc-province').val();
    var $gender = $('#jsc-gender').val();
    var $isvalidated = validateUpdate($first_name, $last_name, $telephone, $birthday);

    var $oldTel = $('#jsc-customter-old-tel').val();
    var $oldBirth = $('#jsc-customter-old-birth').val();
    var $oldProvince = $('#jsc-customter-old-province').val();
    var $oldGender = $('#jsc-customter-old-gender').val();
    var $isConsent = $('#jsc-accepts_marketing').prop('checked');
    var $oldPdpa = $isConsent ? '__pdpa:false' : '__pdpa:true';
    var $newPdpa = $isConsent ? '__pdpa:true' : '__pdpa:false';

    if($gender == 'Male'){
        $gender = 'ชาย';
    } else if($gender == 'Female'){
        $gender = 'หญิง';
    } else if($gender == 'Others'){
        $gender = 'อื่นๆ';
    }

    var $isId = isNaN($id);

    if ($isvalidated) {
      if ($isConsent || $isId) {
        var webhook = 'https://webhooks.mechanic.dev/62ebb2d4-09bd-44ab-a32e-7dd9f6865a5d'; // user/update_pdpa/one
        if ($gender != 'ชาย' && $gender != 'หญิง' && $gender != 'อื่นๆ') {
          $gender = '';
        }
    
        let $data = {
          first_name: $first_name,
          last_name: $last_name,
          birthday: $birthday,
          email: $email,
          telephone: $telephone,
          province: $province,
          gender: $gender,
          isConsent: $isConsent,
          shopify_customer_id: $shopifyId,
          old_tel: $oldTel,
          old_brith: $oldBirth,
          old_pro: $oldProvince,
          old_gen: $oldGender,
          old_pdpa: $oldPdpa,
          pdpa: $newPdpa,
          id_list: $idList
        };
        $.ajax({
          url: webhook,
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
          data: JSON.stringify($data)
        }).done(function () {
          setTimeout(function(){
            $loader.hide();
            location.reload();
          },24000);
        });
      } else {
        var webhook_2 = 'https://webhooks.mechanic.dev/4487bd55-ab93-4cf5-bcfe-e1a422c204ad'; // user/update_pdpa/two
        if ($gender != 'ชาย' && $gender != 'หญิง' && $gender != 'อื่นๆ') {
          $gender = '';
        }
    
        let $data = {
          id: $id,
          first_name: $first_name,
          last_name: $last_name,
          birthday: $birthday,
          email: $email,
          telephone: $telephone,
          province: $province,
          gender: $gender,
          isConsent: $isConsent,
          shopify_customer_id: $shopifyId,
          old_tel: $oldTel,
          old_brith: $oldBirth,
          old_pro: $oldProvince,
          old_gen: $oldGender,
          old_pdpa: $oldPdpa,
          pdpa: $newPdpa,
          id_list: $idList
        };
        $.ajax({
          url: webhook_2,
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
          data: JSON.stringify($data)
        }).done(function () {
          setTimeout(function(){
            $loader.hide();
            location.reload();
          },24000);
        });
      }
    } else {
      $loader.hide();
    }
}

checkSubscriptionMarketing = (evt) =>{
  var $this = $(evt);
  var $isConsent = $this.prop('checked');
  var $submitButton = $('#subscription-submit');

  console.log('checkSubscriptionMarketing - $isConsent: ', $isConsent);

  if ($isConsent) {
      $submitButton.removeClass('disabled-submit');
  } else {
      $submitButton.addClass('disabled-submit');
  }
}

submitSubscriptionPdpa = (evt) =>{
  var $loader = $('.jsc-loader-overlay');
  $loader.show();
  var $this = $(evt);
  var $id = parseInt($('#jsc-customer-pdpa-id').val());
  var $idList = $('#jsc-customer-pdpa-id-list').val();
  var $shopifyId = parseInt($('#jsc-customer-id').val()) || "";
  var $first_name = $('#FirstName').val();
  var $last_name = $('#LastName').val();
  var $email = $('#Email').val();
  var $telephone = $('#jsc-register_mobile').val();
  var $birthday = $('#jsc-birthday').val();
  var $province = $('#jsc-province').val();
  var $gender = $('#jsc-gender').val();
  var $isvalidated = validateUpdate($first_name, $last_name, $telephone, $birthday);

  var $oldTel = $('#jsc-customter-old-tel').val();
  var $oldBirth = $('#jsc-customter-old-birth').val();
  var $oldProvince = $('#jsc-customter-old-province').val();
  var $oldGender = $('#jsc-customter-old-gender').val();
  var $isConsent = $('#jsc-accepts_marketing').prop('checked');
  var $oldPdpa = $isConsent ? '__pdpa:false' : '__pdpa:true';
  var $newPdpa = $isConsent ? '__pdpa:true' : '__pdpa:false';

  var $subscriptionTag = $('#jsc-subscription-tag').val();
  console.log('submitSubscriptionPdpa - shopifyId: ', $subscriptionTag);

  if($gender == 'Male'){
    $gender = 'ชาย';
  } else if($gender == 'Female'){
      $gender = 'หญิง';
  } else if($gender == 'Others'){
      $gender = 'อื่นๆ';
  }

  var $isId = isNaN($id);

  var emailDOM = $('#Email')[0];
  // console.log('emailDOM.checkValidity(): ', emailDOM.checkValidity());
  if ($email == '') {
    $isvalidated = false;
    $('#email_error').show();
  } else {
    $('#email_error').hide();
    if (!emailDOM.checkValidity()) {
      $isvalidated = false;
      $('#email_invalid_error').show();
    } else {
      $('#email_invalid_error').hide();
    }
  }

  if ($isvalidated) {
    let mechanicWebhook = '';
    if ($gender != 'ชาย' && $gender != 'หญิง' && $gender != 'อื่นๆ') {
      $gender = '';
    }
    let $data = {
      first_name: $first_name,
      last_name: $last_name,
      birthday: $birthday,
      email: $email,
      telephone: $telephone,
      province: $province,
      gender: $gender,
      isConsent: $isConsent,
      shopify_customer_id: $shopifyId,
      old_tel: $oldTel,
      old_brith: $oldBirth,
      old_pro: $oldProvince,
      old_gen: $oldGender,
      old_pdpa: $oldPdpa,
      pdpa: $newPdpa,
      id_list: $idList,
      subscription_tag: $subscriptionTag
    };

    if ($shopifyId == '') {
      mechanicWebhook = 'https://webhooks.mechanic.dev/b4c9787c-6f1b-4aa3-8eb3-e64f90c87ecb'; // user/subscription_form/submit
    } else if ($isConsent || $isId) {
      mechanicWebhook = 'https://webhooks.mechanic.dev/62ebb2d4-09bd-44ab-a32e-7dd9f6865a5d'; // user/update_pdpa/one
    } else {
      mechanicWebhook = 'https://webhooks.mechanic.dev/4487bd55-ab93-4cf5-bcfe-e1a422c204ad'; // user/update_pdpa/two
      $data.id = $id;
    }

    $.ajax({
      url: mechanicWebhook,
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify($data)
    }).done(function () {
      $loader.hide();
      console.log('submitSubscriptionPdpa: ', $('#jsc-subscription-form__container'));
      if ($('#jsc-thank-you__container').length) {
        $('#jsc-thank-you__container').css('display', 'block');
        $('#jsc-subscription-form__container').css('display', 'none');
      }
    });
  } else {
    $loader.hide();
    console.log('submitSubscriptionPdpa validation failed: ', $('#jsc-subscription-form__container'));
    if ($('#jsc-thank-you__container').length) {
        $('#jsc-thank-you__container').css('display', 'none');
        $('#jsc-subscription-form__container').css('display', 'flex');
    }
  }
}

validateRegister = ($first_name, $last_name, $email, $telephone, $birthday, $password) =>{
    var $isError = true;

    if ($first_name == '') {
        $('#first_name_error').show();
        $isError = false;
    } else {
        $('#first_name_error').hide();
    }
    if ($last_name == '') {
        $('#last_name_error').show();
        $isError = false;
    } else {
        $('#last_name_error').hide();
    }
    if ($email == '') {
        $('#email_error').show();
        $isError = false;
    } else {
        $('#email_error').hide();
    }
    if ($telephone == '') {
        $('#telephone_error').show();
        $isError = false;
    } else {
        $('#telephone_error').hide();
        if ($telephone.length != 10) {
        $('#telephone_valid').show();
        $isError = false;
        } else {
        if ($telephone.slice(0,1) != '0') {
            $('#telephone_valid').show();
            $isError = false;
        }else {
            $('#telephone_valid').hide();
        }
        }
    }
    if ($birthday == '') {
        $('#birthday_error').show();
        $isError = false;
    } else {
        $('#birthday_error').hide();
    }
    if ($password == '') {
        $('#password_error').show();
        $isError = false;
    } else {
        $('#password_error').hide();
    }

    return $isError;
}

pdpaConsent = (evt) =>{
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    var $this = $(evt);
    var $form = $('#create_customer');
    var $first_name = $form.find('input[name="customer[first_name]"]').val();
    var $last_name = $form.find('input[name="customer[last_name]"]').val();
    var $email = $form.find('input[name="customer[email]"]').val();
    var $telephone = $form.find('input[name="telephone"]').val();
    var $birthday = $form.find('input[name="birthday"]').val();
    var $isConsent = $form.find('#jsc-accepts_marketing').prop('checked');
    var $password = $form.find('input[name="customer[password]"]').val();
    var $isvalidated = validateRegister($first_name, $last_name, $email, $telephone, $birthday, $password);


    setTimeout(function(){
        if ($isvalidated) {
            $('#jsc-customer-tag').val('__tel:'+$telephone+',__birthday:'+$birthday+',__pdpa:'+$isConsent);
            $this.siblings('#register-submit').click();
        }
        $loader.hide();
    },1800);
}

initDate = () =>{
    var startDate = new Date(1900, 1 - 1, 1);
    var currentDate = new Date();
    var endDate = new Date(new Date().getFullYear() - 10, currentDate.getMonth(), currentDate.getDate());
    if ($('#jsc-birthday').length) {
      $('#jsc-birthday').datepicker({
        format: 'yyyy-mm-dd',
        startDate: startDate,
        endDate: endDate,
        startView: 2,
        maxViewMode: 2
      });
    }
}
// End PDPA Function

// Login Register page
loginRegisterTab = (e,i) => {
    var $this = $(e);
  
    $('.jsc-tab-rl').removeClass('active');
    $this.addClass('active');
  
    if (i) {
      // Show Register
      $('#customer-wrapper').find('#create-customer').show();
      $('#customer-wrapper').find('#login-customer').hide();
    } else {
      // Show Login
      $('#customer-wrapper').find('#login-customer').show();
      $('#customer-wrapper').find('#create-customer').hide();
    }
  }
  // End Login Register page
  
// Start CartJS Function
cartJSAddQuery = (vid, qty, obj, isOpenDrawer) => {
// Cart js add item, success callback, error callback

    if ($('#jsc-CartJSEvent').length < 1) {
      $(document).on('cart.requestStarted', function(event, cart) {
        $('.jsc-page-loading').removeAttr("style");
      });
      $(document).on('cart.requestComplete', function(event, cart) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        $('.jsc-page-loading').css("display","none");
        setTimeout(function(){
          if ($('.cart__items[data-count="0"]').length > 0) {
              location.reload();
          }
        },1000);
      });
      var $html = `<input type="hidden" id="jsc-CartJSEvent">`;
      $('body').prepend($html);

      setTimeout(function(){
        CartJS.addItem(vid, qty, obj,
        {
            // Define a success callback to display a success message.
            "success": function(data, textStatus, jqXHR) {
            $.ajax({
                url: '/cart.js',
                dataType: "json",
                cache: false,
                beforeSend: function() {
                console.log('before');
                },
                success: function(cart) {
                }
            });
            },
            // Define an error callback to display an error message.
            "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", errorThrown);
            }
        });
      },500);

    }else{

    CartJS.addItem(vid, qty, obj,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
        $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            beforeSend: function() {
            console.log('before');
            },
            success: function(cart) {
            }
        });
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
        }
    });

    }
}
  
cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
// Cart js add item, success callback, error callback

    if ($('#jsc-CartJSEvent').length < 1) {
      $(document).on('cart.requestStarted', function(event, cart) {
        $('.jsc-page-loading').removeAttr("style");
      });
      $(document).on('cart.requestComplete', function(event, cart) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        $('.jsc-page-loading').css("display","none");
        setTimeout(function(){
          if ($('.cart__items[data-count="0"]').length > 0) {
              location.reload();
          }
        },1000);
      });
      var $html = `<input type="hidden" id="jsc-CartJSEvent">`;
      $('body').prepend($html);

      setTimeout(function(){
        CartJS.updateItemById(vid, qty, obj,
        {
            // Define a success callback to display a success message.
            "success": function(data, textStatus, jqXHR) {
            $.ajax({
                url: '/cart.js',
                dataType: "json",
                cache: false,
                beforeSend: function() {
                console.log('before');
                },
                success: function(cart) {
                }
            });
            },
            // Define an error callback to display an error message.
            "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", errorThrown);
            }
        });
      },500);

    }else{

    CartJS.updateItemById(vid, qty, obj,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
        $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            beforeSend: function() {
            console.log('before');
            },
            success: function(cart) {
            }
        });
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
        }
    });

    }
}
// End CartJS Function
  
//Start onload and onclick all promo
masterPromo = (isDrawer) =>{
        gwpFunction(isDrawer);
        cartGift();
        tierFunction(isDrawer);
        pwpSetValidationCart();
        updateTolimitbundle();
        cartGiftProperties();
}
//End onload and onclick all promo

//Start - Gift properties apps
cartGiftProperties = () =>{
  $('.jsc-update-gwp-apps').each(function(){
    var $key = parseInt($(this).val());
    var $qty = parseInt($(this).attr('data-qty'));
    var $gwpcart_product = {};
    $gwpcart_product['_Cart_GWP'] = 'Free Gift';
    cartJSUpdateQuery($key, $qty, $gwpcart_product);
  });
}
//End - Gift properties apps
//Start GWP promo
gwpFunction = (isOpenDrawer) =>{
    $.when($.getJSON('/cart.js', function(cart) {
  
    })).then(function(cart){
      var $gwpcart_product = {};
      var $addEle = $('.jsc-add-gwp');
      var $updateEle = $('.jsc-update-gwp');
      var $deleteEle = $('.jsc-remove-gwp');
  
      $gwpcart_product['_Promo'] = 'Free Gift';
  
      $addEle.each(function() {
        var $vid = parseInt($(this).val());
        var $qty = parseInt($(this).attr('data-qty'));
  
        $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');
  
        cartJSAddQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
      });
  
      $updateEle.each(function() {
        var $vid = $(this).val();
        var $qty = parseInt($(this).attr('data-qty'));
  
        $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');
  
        cartJSUpdateQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
      });
  
      $deleteEle.each(function() {
        var $vid = $(this).val();
        var $qty = 0;
  
        cartJSUpdateQuery($vid, $qty, {}, isOpenDrawer);
      });
  
    });
}
//End GWP promo
//Start GWP based on cart, product or collection promo
cartGift = () =>{
    addCartGift();
    removeCartGift();
  }
  
  addCartGift = () =>{
    var $elem = $('#jsc-cart-gift');
    var $vid = $elem.val();
    var $obj = {};
    var $promoNo = $elem.attr('data-promo');
  
    $obj['_Cart_Gift'] = $promoNo;
    $obj['_Cart_GWP'] = 'Free Gift';
    if ($elem.length > 0) {
      cartJSAddQuery($vid,1,$obj,true);
    }
    $('.jsc-cart-gift-upt').each(function () {
      $loader.show();
      var $vid = $(this).val();
      var $qty = parseInt($(this).attr('data-qty'));
  
      var $obj = {};
      var $promoNo = $(this).attr('data-promo');
      $obj['_Cart_Gift'] = $promoNo;
      $obj['_Cart_GWP'] = 'Free Gift';
  
      cartJSUpdateQuery($vid, $qty, $obj, false);
    });
  }
  
  removeCartGift = () =>{
    var $elem = $('#jsc-cart-gift-remove');
    var $key = $elem.val();
  
    if ($elem.length > 0) {
      cartJSUpdateQuery($key, 0, {}, true);
    }
  }
//End GWP based on cart, product or collection promo
//Start tier discount promo
tierFunction = (isOpenDrawer) =>{
    var $updateEle = $('.jsc-tier-product');
    var $removeEle = $('.jsc-tier-product-remove');
  
    $updateEle.each(function(){
      var $obj = {};
      var $this = $(this);
      var $key = $this.attr('data-key');
      var $discountVal = $this.val();
      var $discountType = $this.attr('data-discount-type');
      var $tierNo = $this.attr('data-promo-no');
      var $qty = parseInt($this.attr('data-qty'));
  
      $obj['_Quantity-Promo'] = $discountType;
      $obj['_Off-Value'] = $discountVal;
      $obj['_Promo-no'] = $tierNo;
      $obj['_Tier'] = true;
  
      cartJSUpdateQuery($key, $qty, $obj, isOpenDrawer);
    });
  
    $removeEle.each(function(){
      var $this = $(this);
      var $key = $this.val();
      var $promoNo = $this.attr('data-promo-no');
      $.when($.getJSON('/cart.js')).then(function(cart){
        var $items = cart.items;
        for (var i = 0; i < $items.length; i++) {
          var $thisKey = $items[i].key;
          var $thisQty = $items[i].quantity;
          var $thisProps = $items[i].properties;
          var $vID = parseInt($items[i].variant_id);
  
          if ($thisKey == $key && $thisProps['_Promo-no'] == $promoNo) {
            delete $thisProps['_Quantity-Promo'];
            delete $thisProps['_Off-Value'];
            delete $thisProps['_Promo-no'];
            delete $thisProps['_Tier'];
  
            var $isEmptyProperty = $.isEmptyObject($thisProps);
            if ($isEmptyProperty) {
              // if properties is empty then, remove the product and add back
              replaceProduct($thisKey, $vID, $thisQty, isOpenDrawer);
            } else {
              // if properties not empty then, just update the properties
              cartJSUpdateQuery($thisKey, $thisQty, $thisProps, isOpenDrawer);
            }
          }
        }
      });
    });
  }
  
  replaceProduct = ($key, $vid, $qty, isOpenDrawer) =>{
    CartJS.removeItemById($key,
    {
      "success": function(data, textStatus, jqXHR) {
        cartJSAddQuery($vid, $qty, {}, isOpenDrawer);
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
      }
    });
  }
  //End tier discount promo

//Start variant selected in pdp for bundle and pwp
variantOption = (evt, index, setValue) =>{
    var $this = $(evt);
    var $thisImgUrl = $this.find(':selected').attr('data-img');
    var $thisVid = $this.val();
    var $thisPrice = $this.find(':selected').attr('data-price');
    var $thisTitle = $this.find(':selected').text();
    var $thisComparePrice = $this.find(':selected').attr('data-compare-price');
    var $isDiscounted = $this.find(':selected').attr('data-settings-discount') == 'true';
    var $currencyFormat = $('html').attr('data-currency');
    var $variantTitleEle = $this.parent().find('span.jsc-variant-title');
  
    var $hiddenEle = $this.parents('.jsc-container').find('.jsc-hidden');
    var $discountType = $hiddenEle.val();
    var $minusPrice = $discountType == 'percentage-off' ? parseFloat($hiddenEle.attr('data-'+$discountType+'-'+index)) : parseInt($hiddenEle.attr('data-'+$discountType+'-'+index));
  
    // update image
    $this.parent().find('img').attr('src', $thisImgUrl);
  
    // update price
    if ($isDiscounted) { // if discount value is not empty in theme settings, then calculate the price
      var $discountedValue = 0;
      if ($discountType == 'percentage-off') {
        $discountedValue = $thisPrice * $minusPrice;
      } else {
        $discountedValue = $thisPrice - $minusPrice;
      }
  
      var price = $thisComparePrice;
      var discountprice = $thisPrice;
  
      $this.siblings('.jsc-price').find('strike').text(price);
      $this.siblings('.jsc-price').find('span').text(discountprice);
    } else { // if discount value is empty in theme settings, then show normal price
      if ($thisComparePrice) {
        var comparePrice = $thisComparePrice;
        $this.siblings('.jsc-price').find('strike').text(comparePrice);
        $this.siblings('.jsc-price').find('strike').show();
      } else {
        $this.siblings('.jsc-price').find('strike').hide();
      }
      var price = $thisPrice;
      $this.siblings('.jsc-price').find('span').text(price);
    }
  
    // update variant ID
    $this.parent().attr('data-vid', $thisVid);
  
    // This function is to hide atc btn and show limit message if pwp reached the set limit
    if (setValue) {
      pwpSetValidationPdp(setValue, $this);
    }
  
    if ($variantTitleEle.length > 0) {
      $variantTitleEle.html($thisTitle);
    }
  }
  //End variant selected in pdp for bundle and pwp
  
  //Start PWP promo
  pwpAddToCart = (evt,discount2, discountType, index) =>{
    var $this = $(evt);
    var properties1 = {};
    var properties2 = {};
    var vid1 = parseInt($this.parent().find('.jsc-pwp-col-1').attr('data-vid'));
    var vid2 = parseInt($this.parent().find('.jsc-pwp-col-2').attr('data-vid'));
    var $bindId = vid1+'-'+vid2;
  
  
    properties1['_PWP'] = 'Master';
    properties1['_BindID'] = $bindId;
    properties1['_Promo-No'] = index;
  
  
    properties2['_Quantity-Promo'] = discountType;
    properties2['_Off-Value'] = discount2;
    properties2['_PWP'] = 'Child';
    properties2['_BindID'] = $bindId;
    properties2['_Promo-No'] = index;
  
    cartJSAddQuery(vid1, 1, properties1, true);
    cartJSAddQuery(vid2, 1, properties2, true);

    var cartType = $('#cart-type').val();
    
    if (cartType == 'page') {
      $(document).on('cart.requestComplete', function(event, cart) {
        if (location.href.includes('/cart')) {
          console.log('no need redirect');
        }else{
          window.location.href = '/cart';
        }
      });
    }

    /*
    $(document).on('cart.requestComplete', function(event, cart) {
      setTimeout(function(){
        masterPromo(false);
      },500);
    });
    */
  }
  
  removePwp = (evt, bindid, pwp) =>{
    setTimeout(function(){
      $.when($.getJSON('/cart.js')).then(function(cart){
        var $items = cart.items;
        for (var i = 0; i < $items.length; i++) {
          var $thisKey = $items[i].key;
          var $thisQty = $items[i].quantity;
          var $thisProps = $items[i].properties;
          var $vID = parseInt($items[i].variant_id);
  
          if ($thisProps['_BindID'] == bindid) {
  
            if (pwp == 'Master') {
              // if customer remove master product we remove the child product
              cartJSUpdateQuery($thisKey, 0, {}, true);
            } else if (pwp == 'Child') {
              // if customer remove child product we keep the master product, but remove the pwp properties
              delete $thisProps['_Quantity-Promo'];
              delete $thisProps['_Off-Value'];
              delete $thisProps['_BindID'];
              delete $thisProps['_PWP'];
              delete $thisProps['_Promo-No'];
  
              var $isEmptyProperty = $.isEmptyObject($thisProps);
              if ($isEmptyProperty) {
                // if properties is empty then, remove the product and add back
                replaceProduct($thisKey, $vID, $thisQty, true);
              } else {
                // if properties not empty then, just update the properties
                cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
              }
            }
          }
        }
      });
    },900);
    $(document).on('cart.requestComplete', function(event, cart) {
      pwpSetValidationCart();
    });
  }
  
  updatePwp = (evt,bindid) =>{
    setTimeout(function(){
      $.when($.getJSON('/cart.js')).then(function(cart){
        var $items = cart.items;
        for (var i = 0; i < $items.length; i++) {
          var $thisKey = $items[i].key;
          var $thisQty = $items[i].quantity;
          var $thisProps = $items[i].properties;
          $thisQty -= 1;
          if ($thisProps['_BindID'] == bindid && $thisProps['_PWP'] == 'Child') {
            cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
            console.log('slow333', $thisQty);
          }
        }
      });
    },900);
  }
  
  pwpSetValidationPdp = (setValue, $this) =>{
    var $v1 = $this.parents('.jsc-container').find('.jsc-pwp-col-1').attr('data-vid');
    var $v2 = $this.parents('.jsc-container').find('.jsc-pwp-col-2').attr('data-vid');
    var $bId = $v1+'-'+$v2;
    var $isInCart = false;
    $.when($.getJSON('/cart.js')).then(function(cart){
      var $items = cart.items;
      for (var i = 0; i < $items.length; i++) {
        var $thisQty = $items[i].quantity;
        var $thisProps = $items[i].properties;
  
        if ($thisProps['_BindID'] == $bId && $thisProps['_PWP'] == 'Child') {
          if ($thisQty >= setValue) { // if pwp variant have reached set limit
            $this.parents('.jsc-container').find('.jsc-set-limit-msg').show();
            $this.parents('.jsc-container').find('.jsc-atc-btn').hide();
          } else { // if pwp variant not yet reached set limit
            $this.parents('.jsc-container').find('.jsc-set-limit-msg').hide();
            $this.parents('.jsc-container').find('.jsc-atc-btn').show();
          }
          $isInCart = true;
        }
      }
  
      // if variant is not in cart
      if (!$isInCart) {
        $this.parents('.jsc-container').find('.jsc-set-limit-msg').hide();
        $this.parents('.jsc-container').find('.jsc-atc-btn').show();
      }
    });
  }
  
  pwpSetValidationCart = () =>{
    var $pwpContainer = $('.jsc-pwp-container');
  
    $pwpContainer.each(function(){
      var $this = $(this);
      var $v1 = $this.find('.jsc-pwp-col-1').attr('data-vid');
      var $v2 = $this.find('.jsc-pwp-col-2').attr('data-vid');
      var $bId = $v1+'-'+$v2;
      var $isInCart = false;
      var $setValue = parseInt($this.attr('data-set'));
  
      if ($setValue) {
        $.when($.getJSON('/cart.js')).then(function(cart){
          var $items = cart.items;
          for (var i = 0; i < $items.length; i++) {
            var $thisQty = $items[i].quantity;
            var $thisProps = $items[i].properties;
  
            if ($thisProps['_BindID'] == $bId && $thisProps['_PWP'] == 'Child') {
              if ($thisQty >= $setValue) { // if pwp variant have reached set limit
                $this.find('.jsc-set-limit-msg').show();
                $this.find('.jsc-atc-btn').hide();
              } else { // if pwp variant not yet reached set limit
                $this.find('.jsc-set-limit-msg').hide();
                $this.find('.jsc-atc-btn').show();
              }
              $isInCart = true;
            }
          }
          // if variant is not in cart
          if (!$isInCart) {
            $this.find('.jsc-set-limit-msg').hide();
            $this.find('.jsc-atc-btn').show();
          }
        });
      }
    });
  }
  //End PWP promo
//Start bundle promo
bundleAddToCart = (evt,discount1,discount2, discountType, i) =>{
    var $this = $(evt);
    var properties1 = {};
    var properties2 = {};
    var vid1 = parseInt($this.parent().find('.jsc-bundle-col-1').attr('data-vid'));
    var vid2 = parseInt($this.parent().find('.jsc-bundle-col-2').attr('data-vid'));
    var $bindId = vid1+'-'+vid2;
  
  
    properties1['_Quantity-Promo'] = discountType;
    properties1['_Off-Value'] = discount1;
    properties1['_Bundle'] = true;
    properties1['_BindID'] = $bindId;
    properties1['_Promo-no'] = i;
  
    properties2['_Quantity-Promo'] = discountType;
    properties2['_Off-Value'] = discount2;
    properties2['_Bundle'] = true;
    properties2['_BindID'] = $bindId;
    properties2['_Promo-no'] = i;
  
    cartJSAddQuery(vid1, 1, properties1, true);
    cartJSAddQuery(vid2, 1, properties2, true);
    
    var cartType = $('#cart-type').val();
    if (cartType == 'page') {
      $(document).on('cart.requestComplete', function(event, cart) {
        if (location.href.includes('/cart')) {
          console.log('no need redirect');
        }else{
          window.location.href = '/cart';
        }
      });
    }

    /*
    $(document).on('cart.requestComplete', function(event, cart) {
      setTimeout(function(){
        masterPromo(false);
      },500);
    });
    */
  }
  
  updateTolimitbundle = () =>{
    var $uptEle = $('.jsc-update-bundle-fix');
    $uptEle.each(function(){
      var $this = $(this);
      var $key = $this.val();
      var discountType = $this.attr('data-discType');
      var discount = $this.attr('data-offvalue');
      var $bindId = $this.attr('data-bindId');
      var i = $this.attr('data-promo');
      var $thisQty = $this.attr('data-qty');
      var properties = {};
      properties['_Quantity-Promo'] = discountType;
      properties['_Off-Value'] = discount;
      properties['_Bundle'] = true;
      properties['_BindID'] = $bindId;
      properties['_Promo-no'] = i;
      properties['_Limit-Discount'] = true;
      cartJSUpdateQuery($key, $thisQty, properties, true);
    });
  }
  
  removeBundle = (evt, bindid, key) =>{
    cartJSUpdateQuery(key, 0);
    $(document).on('cart.requestComplete', function(event, cart) {
      bundleCartAjax(bindid);
    });
  }
  
  removeBundleOnThemeSettings = () =>{
    var $removeEle = $('.jsc-remove-bundle');
  
    $removeEle.each(function(){
      var $this = $(this);
      var $bindId = $this.val();
      var $container = $('.'+$this.attr('data-container'));
  
      if ($container.length > 0) {
        $container.hide();
      }
  
      setTimeout(function(){
        bundleCartAjax($bindId);
      },900);
    })
  
  }
  
  bundleCartAjax = (bindid) =>{
    $.when($.getJSON('/cart.js')).then(function(cart){
      var $items = cart.items;
      for (var i = 0; i < $items.length; i++) {
        var $thisKey = $items[i].key;
        var $thisQty = $items[i].quantity;
        var $thisProps = $items[i].properties;
        var $vID = parseInt($items[i].variant_id);
  
        if ($thisProps['_BindID'] == bindid) {
          delete $thisProps['_Quantity-Promo'];
          delete $thisProps['_Off-Value'];
          delete $thisProps['_Bundle'];
          delete $thisProps['_BindID'];
          delete $thisProps['_Promo-no'];
  
          var $isEmptyProperty = $.isEmptyObject($thisProps);
          if ($isEmptyProperty) {
            // if properties is empty then, remove the product and add back
            replaceProduct($thisKey, $vID, $thisQty, true);
          } else {
            // if properties not empty then, just update the properties
            cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
          }
        }
      }
    });
  }
  //End bundle promo

  //Cookies settings
  setCookies = (cname,cval,days) =>{
    const d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
  
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cval + ";" + expires + ";path=/";
  }
  
  getCookies = (cname) =>{
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  acceptCookies = (e) =>{
    var $this = $(e);
  
    $this.parents('.jsc-cookies-container').hide();
  
    setCookies('jsc-accept-cookie', true, 120);
  }
  
  onLoadCookieBar = () =>{
    var isAccpet = getCookies('jsc-accept-cookie') === 'true';
    console.log('cookies accepted',isAccpet)
    if (isAccpet) {
      $('.jsc-cookies-container').hide();
    }
    else {
      $('.jsc-cookies-container').removeClass('d-none');
    }
  }
  // Cookies settings end

  // init flickity slider
  initFlickity = (e) => {
    if ($(window).width() > 810) {
      if (e == 'jsc-recommendations-slider') {
        if ($('.jsc-recommendations-slider .grid__item.grid-product').length > 5) {
          setTimeout(function () {
            $('.'+e).flickity({
              contain: true,
              wrapAround: true,
              pageDots: true,
              prevNextButtons: false,
              imagesLoaded: true,
              lazyLoad: 1,
              freeScroll: true
            });
          }, 900); 
        }
      } else {
        if ($('.jsc-recently-slider .grid__item.grid-product').length > 5) {
          setTimeout(function () {
            $('.'+e).flickity({
              contain: true,
              wrapAround: true,
              pageDots: true,
              prevNextButtons: false,
              imagesLoaded: true,
              lazyLoad: 1,
              freeScroll: true
            });
          }, 900); 
        }
      }
    }
  }
  // init flickity slider end

  // shop by category
  initShopByCategorySlider = () => {
    var $carousel = $('.jsc-category-collections.jsc-category-slide');
    if (!$carousel.length) return; 
    if (window.innerWidth <= 768) {
      $carousel.flickity({
        contain: true,
        wrapAround: true,
        pageDots: true,
        prevNextButtons: false,
        imagesLoaded: true,
        lazyLoad: 1,
        adaptiveHeight: true,
      });
    } else {
      if ($carousel.data('flickity')) {
        $carousel.flickity('destroy');
      }
    }
  }
  // shop by category

  // shop by category 2
initShopByCategorySlider2 = () => { 
  var $carousel = $('.jsc-category-collections-2');

  if (!$carousel.length) return;

  $carousel.flickity({
    contain: true,
    wrapAround: true,
    pageDots: true,
    prevNextButtons: true,
    imagesLoaded: true,
    lazyLoad: 1,
    adaptiveHeight: true,
    arrowShape: {
      x0: 40,
      x1: 70, y1: 40,
      x2: 70, y2: 45,
      x3: 35
    }
  });
}

  selectTab = (e, cls) => {
    var $this = $(e);

    $this.siblings().removeClass('category-is-selected');
    $('.jsc_'+cls).addClass('category-is-selected');
    
    $('.jsc-category-collections-2').removeClass('category-content-is-selected');
    $('.jsc_content_' + cls).addClass('category-content-is-selected');
    
    $('.jsc-category-collections-2').flickity('resize');
  }
  // shop by category 2

  formatString = (n) =>{
    var chars = n.substring(0,3);
    var xChar = n.substr(3).replace(/\D/g,'x');
  
    var newLastName = chars + xChar;
  
    return newLastName;
  }
  oneCardRemove = (e,cusId) => {
    var $this = $(e);
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    
    // Run Mechanic webhook
    let $data = {
      customerId: cusId
    };
    $.ajax({
      url: 'https://webhooks.mechanic.dev/51ce14b1-4c86-4912-969d-a255b39d9d79',
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify($data)
    }).done(function () {
      $('#jsc-id-num').val('');
      $loader.hide();
      $this.hide();
    });
  }
  oneCardVerfication = (e, dT, cusId) =>{
    var $this = $(e);
    var $loader = $('.jsc-loader-overlay');
    var $oneCardNoEle = $('#jsc-id-num');
    var $oneCardNo = $oneCardNoEle.val();
  
    $loader.show();

    if ($oneCardNo != '') {
      $('#jsc-one-card-error').hide();
      let _data = {
        sourceTransID: `CMG_${cusId}_${dT}`,
        requestTime: dT,
        cardNo: $oneCardNo,
        customerId: cusId
      };
      $.ajax({
        url: 'https://webhooks.mechanic.dev/21617560-507d-44e1-9764-30ffa2198d37', // user/migrate/onecard
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        data: JSON.stringify(_data)
      }).done(function () {
        setTimeout(function(){
          $loader.hide();
          location.reload();
        },6000);
      });
    } else {
      $('#jsc-one-card-error').show();
      $('#jsc-one-card-ajax-error').hide();
      $('#jsc-one-card-success').hide();
      $loader.hide();
    }
  }

  removeOneCardError = () =>{
    var isTriggerRemoveTag = $('#trigger-remove-error').length;
  
    if (isTriggerRemoveTag) {
      var tag_val = $('#trigger-remove-error').val();
      var customer_id = $('#trigger-remove-error').attr('data-id');
      let _data = {
        tag: tag_val,
        customer_id: customer_id
      };
      $.ajax({
        url: 'https://webhooks.mechanic.dev/5d57a05d-8c5f-452e-963e-04084ae92108', // user/migrate/onecard_remove_error
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        data: JSON.stringify(_data)
      }).done(function () {
        
      });
    }
  }
  
  isInvoice = (e) =>{
    var $this = $(e);
    var $val = $this.val();
    var $html = `<p class="cart-attribute__field jsc-personal-company">
      <label class="fontWeight-9 line-height-2 ">คุณต้องการขอใบกำกับภาษีในนามบุคคลหรือนิติบุคคล</label>
      <input type="radio" onchange="isPersonalOrCompany(this)" id="jsc-personal-radio" class="vertical-middle jsc-radio cursor" name="attributes[Are you a Personal or Company (Individual Company)]" value="Personal"> <label class="vertical-middle fontWeight-9 cursor p-r-25 inline m-b-0" for="jsc-personal-radio">ส่วนบุคคล</label>
      <input type="radio" onchange="isPersonalOrCompany(this)" id="jsc-company-radio" class="vertical-middle jsc-radio cursor" name="attributes[Are you a Personal or Company (Individual Company)]" value="Company"> <label class="vertical-middle fontWeight-9 cursor inline m-b-0" for="jsc-company-radio">ในนามบริษัท</label><br>
    </p>`;
  
    if ($val == 'Yes') {
      $('.jsc-tax-invoice-inputs').append($html);
    } else {
      if ($('.jsc-personal-company').length) {
        $('.jsc-personal-company').remove();
      }
      if ($('.jsc-personal').length) {
        $('.jsc-personal').remove();
      }
      if ($('.jsc-company').length) {
        $('.jsc-company').remove();
      }
    }
  }
  
  isPersonalOrCompany = (e) =>{
    var $this = $(e);
    var $val = $this.val();
  
    if ($val == 'Personal') {
      var $html = `<div class="jsc-personal jsc-inputs-details">
        <p class="fontWeight-9 line-height-2">ส่วนบุคคล</p>
        <p class="cart-attribute__field relative m-b-20">
          <label class="Form__FloatingLabel opacity-1" for="tax-id">เลขประจำตัวผู้เสียภาษี<span style="color: red;"> *</span></label>
          <input required class="required full-width" id="tax-id" maxlength="13" type="text" name="attributes[vat_id]" value="">
        </p>
        <p id="jsc-required-text" class="m-t-15" style="margin-top: -5px; display: none; color: red;font-size: 10px;">* This is a required field</p>
        <span class="btn cursor" onclick="saveCartAttr(this)">บันทึกเพื่ออัปเดต</span>
      </div>`;
      $('.jsc-tax-invoice-inputs').append($html);
      if ($('.jsc-company').length) {
        $('.jsc-company').remove();
      }
    } else {
      var $html = `<div class="jsc-company jsc-inputs-details">
        <p class="fontWeight-9 line-height-2">ในนามบริษัท</p>
        <p class="cart-attribute__field relative m-b-30">
          <label class="Form__FloatingLabel opacity-1" for="tax-id">เลขประจำตัวผู้เสียภาษี<span style="color: red;"> *</span></label>
          <input required class="required full-width" id="tax-id" maxlength="13" type="text" name="attributes[vat_id]" value="">
        </p>
        <p class="cart-attribute__field relative m-b-30">
          <label class="Form__FloatingLabel opacity-1" for="company-name">ชื่อบริษัท<span style="color: red;"> *</span></label>
          <input required class="required full-width" id="company-name" type="text" name="attributes[company]" value="">
        </p>
        <p class="cart-attribute__field relative m-b-30">
          <label class="Form__FloatingLabel opacity-1" for="branch-type">ประเภทของสำนักงาน<span style="color: red;"> *</span></label>
          <select onchange="onChangeBType(this)" required class="required full-width" id="branch-type" name="attributes[Branch Type]">
            <option value="Headquarter">สำนักงานใหญ่</option>
            <option value="Branch">สาขา</option>
          </select>
        </p>
        <p class="cart-attribute__field relative m-b-20">
          <label class="Form__FloatingLabel opacity-1" for="branch-id">รหัสสาขา<span style="color: red;"> *</span></label>
          <input required class="required full-width" id="branch-id" type="text" maxlength="5" name="attributes[branch_id]" value="00000">
          <span id="jsc-b-id-overlay"></span>
        </p>
        <p id="jsc-required-text" class="m-t-15" style="margin-top: -5px; display: none; color: red;font-size: 10px;">* This is a required field</p>
        <span class="btn cursor" onclick="saveCartAttr(this)">บันทึกเพื่ออัปเดต</span>
      </div>`;
      $('.jsc-tax-invoice-inputs').append($html);
      if ($('.jsc-personal').length) {
        $('.jsc-personal').remove();
      }
    }
  }
  
  saveCartAttr = (e) =>{
    var $this = $(e);
    var $inputs = $this.parents('.jsc-inputs-details').find('input');
    var isFilled = true;
  
    $inputs.each(function(){
      var $_this = $(this);
      var $_val = $_this.val();
      console.log('dddd',$_val);
  
      if (!$_val) {
        isFilled = false;
      }
    });
  
    if (isFilled) {
      $('#jsc-required-text').hide();
      $this.text('บันทึกเสร็จแล้ว!');
      cartJSSaveAttr();
    } else {
      $('#jsc-required-text').show();
      $this.text('บันทึกเพื่ออัปเดต');
    }
  }

  cartJSSaveAttr = () =>{
    var input_elements = $('.jsc-tax-invoice').find('input');
    var dataObject = {};
    var isPersonal = false;
  
    input_elements.each(function() {
      var inputType = $(this).attr('type');
      var inputName = $(this).attr('name');
      var inputValue;
  
      if (inputType === 'text') {
        // For text inputs, capture the value directly
        inputValue = $(this).val();
      } else if (inputType === 'radio' && $(this).is(':checked')) {
        // For radio inputs, capture the value only if it's checked
        inputValue = $(this).val();
        if ($(this).val() == 'Personal') {
          isPersonal = true;
        }
      }
  
      // Extract the value inside the square brackets
      var matches = inputName.match(/\[([^\]]+)\]/);
      var key = matches ? matches[1] : null;
  
      if (isPersonal) {
        dataObject['company'] = 'N/A';
        dataObject['branch_id'] = 'N/A';
      }
  
      // Add the data to the object if name and value are defined
      if (inputName && inputValue !== undefined) {
        dataObject[key] = inputValue;
      }
    });
  
    // set attribute
    CartJS.setAttributes(dataObject);
  }
  
  getTaxAttr = () =>{
    
    $.getJSON('/cart.js', function(cart) {
      var cart_attr_obj = cart.attributes;
      console.log('ujuj',cart_attr_obj);
      if (cart_attr_obj.isFullTax) {
        $(`#jsc-${cart_attr_obj.isFullTax.toLowerCase()}-radio`).click();
      }
      if (cart_attr_obj['Are you a Personal or Company (Individual Company)']) {
        $(`#jsc-${cart_attr_obj['Are you a Personal or Company (Individual Company)'].toLowerCase()}-radio`).click();
      }
      if ($('#tax-id').length != 0) {
        $('#tax-id').val(cart_attr_obj.vat_id);
      }
      if ($('#company-name').length != 0) {
        $('#company-name').val(cart_attr_obj.company);
      }
      if ($('#branch-id').length != 0) {
        $('#branch-id').val(cart_attr_obj.branch_id);
      }
    });
    
  }
  
  onChangeBType = (e) => {
    var $this = $(e);
    var $val = $this.val();
  
    if ($val == 'Headquarter') {
      $('#jsc-b-id-overlay').show();
      $('#branch-id').val('00000');
    } else {
      $('#jsc-b-id-overlay').hide();
      $('#branch-id').val('');
    }
  }

  checkBannerVisible = () => {
    console.log("START");
    $('.product-block').each(function() {
      if ($(this).find('span[style="display:none;"][data-visible="none"]').length > 0) {
        console.log("FIND");
        $(this).css('display', 'none');
      }
    });
  }

openChat = (e) => {
  var $this = $(e);
  $('#lisa-open-button').click();
}

openChatFromPageFly = () =>{
  $('.jsc-open-chat').click(function(){
    $('#lisa-open-button').click();
  });
}

/* window resize */
$(window).resize(function() {
  initShopByCategorySlider();
});
updatePaginationStyles = (swiper) => {
  const paginationBullets = $(swiper.el).find('.swiper-pagination-bullet');
  const totalSlides = paginationBullets.length;
  const bulletWidth = 100 / totalSlides;

  paginationBullets.each(function() {
     $(this).css('width', `${bulletWidth}%`);
  });
}

initFeaturedCollectionSwiper = () => {
  $('.swiper.featured-collection__swiper').each(function(index, element) {
      var _this = $(element);
      var autoplay = _this.data('autoplay');
      var autoplaySpeed = _this.data('autoplay-speed');
      var per_row = _this.data('per-row');

      var swiper_option = {
          slidesPerView: 2,
          spaceBetween: 10,
          loop: true,
          on: {
             init: function () {
                updatePaginationStyles(this);
             },
             resize: function () {
                updatePaginationStyles(this);
             },
          },
          pagination: {
             el: ".swiper-pagination",
             clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          initialSlide : 0,
          breakpoints: {
            320: {
              slidesPerView: 2.2,
              spaceBetween: 10,
            },
            480: {
              slidesPerView: 3.5,
              spaceBetween: 12,
            },
            768: {
              slidesPerView: per_row ? per_row - 0.5 : 2.5,
              spaceBetween: 15,
            },
          }
      }

      if (autoplay && autoplaySpeed != '') {
          swiper_option['autoplay'] = {
              delay: autoplaySpeed,
              disableOnInteraction: false
          }
      }

      if (per_row) {
        swiper_option['breakpoints']['1024'] = {
          slidesPerView: per_row - 1,
        },
        swiper_option['breakpoints']['768'] = {
          slidesPerView: 2.5,
        }
      } else {
        swiper_option['breakpoints']['1024'] = {
          slidesPerView: 4,
        },
        swiper_option['breakpoints']['768'] = {
          slidesPerView: 2.5,
        };
      }
      // console.log('swiper_option: ', swiper_option);
      var swiper = new Swiper(this, swiper_option);
  });
}


initStylingGuideSwiper = () => {
  $('.swiper.stylingguide__swiper').each(function(index, element) {
      var _this = $(element);
      var autoplay = _this.data('autoplay');
      var autoplaySpeed = _this.data('autoplay-speed');
      var per_row = _this.data('per-row');

      var swiper_option = {
        slidesPerView: per_row ,   
        slidesPerGroup: per_row,  
        spaceBetween: 10,  
          loop: true,
          on: {
             init: function () {
                updatePaginationStyles(this);
             },
             resize: function () {
                updatePaginationStyles(this);
             },
          },
          pagination: {
             el: ".swiper-pagination",
             clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          initialSlide : 0,
          breakpoints: {
            0: {
              slidesPerView: 1,
              slidesPerGroup: 1,
            },
            480: {
              slidesPerView: 2,
            }
          }
      }

      if (autoplay && autoplaySpeed != '') {
          swiper_option['autoplay'] = {
              delay: autoplaySpeed,
              disableOnInteraction: false
          }
      }

      if (per_row) {
        swiper_option['breakpoints']['768'] = {
          slidesPerView: per_row,
        }
      } else {
        swiper_option['breakpoints']['768'] = {
          slidesPerView: 4,
        };
      }
      // console.log('swiper_option: ', swiper_option);
      var swiper = new Swiper(this, swiper_option);
  });
}



MiniSliderSwiper = () => {
  $('.swiper.content_minislider').each(function(index, element) {
      var _this = $(element);
      var autoplay = _this.data('autoplay');
      var autoplaySpeed = _this.data('autoplay-speed');
      var per_row = _this.data('per-row');

      var swiper_option = {
        slidesPerView: 1 ,   
        slidesPerGroup: 1,  
        spaceBetween: 0,  
          loop: true,
          on: {
             init: function () {
                updatePaginationStyles(this);
             },
             resize: function () {
                updatePaginationStyles(this);
             },
          },
          pagination: {
             el: ".swiper-pagination",
             clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          initialSlide : 0,
          breakpoints: {
            0: {
              slidesPerView: 1,
              slidesPerGroup: 1,
            },
            480: {
              slidesPerView: 1,
            }
          }
      }

      if (autoplay && autoplaySpeed != '') {
          swiper_option['autoplay'] = {
              delay: autoplaySpeed,
              disableOnInteraction: false
          }
      }

      if (per_row) {
        swiper_option['breakpoints']['768'] = {
          slidesPerView: per_row,
        }
      } else {
        swiper_option['breakpoints']['768'] = {
          slidesPerView: 1,
        };
      }
      // console.log('swiper_option: ', swiper_option);
      var swiper = new Swiper(this, swiper_option);
  });
}